// extracted by mini-css-extract-plugin
module.exports = {"card":"IndustryManager-module__card___2RGIL","table":"IndustryManager-module__table___gnbGQ"};